(function () {
  var body = document.body;

  // Mobile drawer
  var drawer = document.getElementById('skn-drawer');
  var overlay = document.querySelector('[data-skn-overlay]');
  var openBtn = document.querySelector('[data-skn-menu-open]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    body.classList.add('no-scroll');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    body.classList.remove('no-scroll');
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.querySelectorAll('[data-skn-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Login / recover password toggle
  var loginForm = document.getElementById('skn-login-form');
  var recoverForm = document.getElementById('skn-recover-form');
  var showRecover = document.getElementById('skn-toggle-recover');
  var showLogin = document.getElementById('skn-toggle-login');

  if (showRecover) showRecover.addEventListener('click', function (e) {
    e.preventDefault();
    if (loginForm) loginForm.hidden = true;
    if (recoverForm) recoverForm.hidden = false;
  });
  if (showLogin) showLogin.addEventListener('click', function (e) {
    e.preventDefault();
    if (recoverForm) recoverForm.hidden = true;
    if (loginForm) loginForm.hidden = false;
  });

  // Customer addresses page
  var newToggle = document.getElementById('skn-new-toggle');
  if (newToggle) newToggle.addEventListener('click', function () {
    var el = document.getElementById('skn-new-address');
    if (el) el.hidden = !el.hidden;
  });
  document.querySelectorAll('select[data-default]').forEach(function (select) {
    select.value = select.getAttribute('data-default');
  });
})();
